import { render, staticRenderFns } from "./PleitoParecerFinanceiro.vue?vue&type=template&id=2ad54cf6"
import script from "./PleitoParecerFinanceiro.vue?vue&type=script&lang=js"
export * from "./PleitoParecerFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports